'use strict'

const UNKNOWN_VERSION = 'unknown'
const isValidVersionString = version => /^\d+\.\d+\.\d+$/.test(version)

module.exports = url => {
  try {
    const split = url.split('/')
    const possibleVersion = split[split.length - 2]
    return isValidVersionString(possibleVersion)
      ? possibleVersion
      : UNKNOWN_VERSION
  } catch (e) {
    return UNKNOWN_VERSION
  }
}

module.exports.UNKNOWN_VERSION = UNKNOWN_VERSION
